<template>
  <div
    class="sf-toggle-switch"
    :class="{ 'sf-toggle-switch--labeled': isLabeled }"
  >
    <label
      class="sf-toggle-switch__container"
      :class="{ 'sf-toggle-switch--labeled__container': isLabeled }"
    >
      <input
        type="checkbox"
        class="sf-toggle-switch__input"
        :class="{ 'sf-toggle-switch--labeled__input': isLabeled }"
        :checked="taxOff"
        :disabled="disabled"
        @change="toggleTax"
      />
      <span
        class="sf-toggle-switch__checkmark"
        :class="{ 'sf-toggle-switch--labeled__checkmark': isLabeled }"
      >
        <template v-if="isLabeled">
          <span
            class="sf-toggle-switch__label sf-toggle-switch__label--left"
            :class="{ 'sf-toggle-switch--labeled__label--left': isLabeled }"
          >
            {{ labelLeft }}
          </span>
          <span
            class="sf-toggle-switch__label sf-toggle-switch__label--right"
            :class="{ 'sf-toggle-switch--labeled__label--right': isLabeled }"
          >
            {{ labelRight }}
          </span>
        </template>
      </span>
    </label>
  </div>
</template>
  
<script>
import { defineComponent, inject, onMounted, watch } from "@nuxtjs/composition-api";
import { useUser } from "@wemade-vsf/customer";


export default defineComponent ({
  name: "SfToggleSwitch",
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLabeled: {
      type: Boolean,
      default: false, 
    },
    labelLeft: {
      type: String,
      default: "På",
    },
    labelRight: {
      type: String,
      default: "Av", 
    },
  },
  setup() {
    const taxOff = inject("taxOff");
    const { user } = useUser();

    const toggleTax = (event) => {
      taxOff.value = event.target.checked;
      localStorage.setItem("taxOff", JSON.stringify(taxOff.value));
    };

    onMounted(() => {
      const storedTaxOff = localStorage.getItem("taxOff");
      if (storedTaxOff === null && user.value?.taxvat) {
        taxOff.value = true;
        localStorage.setItem("taxOff", JSON.stringify(taxOff.value));
      } else {
        taxOff.value = storedTaxOff === "true";
      }
    });

    watch(user, (verifyUser) => {
      const storedTaxOff = localStorage.getItem("taxOff");
      if (storedTaxOff === null && verifyUser?.taxvat) {
        taxOff.value = true;
        localStorage.setItem("taxOff", JSON.stringify(taxOff.value));
      }
    });


    return {
      taxOff,
      toggleTax,
    };
  },
});
</script>
  
<style lang="scss">
@import "@storefront-ui/shared/styles/components/molecules/SfToggleSwitch.scss";
</style>
